export { default as detectLanguage } from './detectLanguage';

export { default as changeBrowserLanguage } from './changeBrowserLanguage';
